<template>
  <section class="px-6 md:px-10 lg:px-16 pb-10">
    <div class="relative mx-auto max-w-5xl rounded-3xl bg-[#070D3A] px-8 py-14 md:px-16 md:py-20 text-white shadow-xl">
      <!-- Título -->
      <header class="text-center max-w-3xl mx-auto mb-14">
        <h2 class="text-3xl md:text-4xl font-bold mb-12">
          {{ $t('whyChooseUs.title') }}
        </h2>
        <p class="text-lg md:text-lg text-white/90 leading-relaxed md:md:whitespace-pre-line">
          {{ $t('whyChooseUs.description') }}
        </p>
      </header>

      <!-- Grid de beneficios -->
      <ul class="grid grid-cols-1 sm:grid-cols-2 gap-6 max-w-5xl mx-auto auto-rows-fr" role="list">
        <li
          v-for="(item, index) in benefits"
          :key="index"
          class="h-full flex items-center justify-center bg-white text-[#030515] rounded-2xl p-3 md:px-6 md:py-6 text-center font-semibold shadow-sm transition-all duration-300 ease-out hover:-translate-y-1 hover:shadow-lg md:md:whitespace-pre-line"
        >
          {{ item }}
        </li>
      </ul>
    </div>
  </section>
</template>

<script>
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { i18n } from '@/i18n/i18n'

export default {
  name: 'WhyChooseUs',
  setup() {
    useI18n()

    // Read the loaded locale messages directly so we always get an array
    const benefits = computed(() => {
      const currentLocale = i18n.global.locale.value
      const msgs = i18n.global.getLocaleMessage(currentLocale) || {}
      return msgs?.whyChooseUs?.benefits || []
    })

    return {
      benefits
    }
  }
}
</script>
